import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { AdminService } from "../../services/admin.service";
import { apiUrl } from "../../global/global";
import { ImageUrls } from "../../services/s3buket";
import { MessagingService } from "src/app/services/messaging.service";
import { HttpParams } from "@angular/common/http";

@Component({
  selector: "app-notification-management",
  templateUrl: "./notification-management.component.html",
  styleUrls: ["./notification-management.component.css"]
})
export class NotificationManagementComponent implements OnInit {
  allData:any=[];
  globalUrl = ImageUrls.BaseUrl + ImageUrls.directories.users;
  limit = 10;
	skip = 1;
	totalCount: any;
	noData: any = false
	modalScrollDistance = 2;
	modalScrollThrottle = 50; 
  unReadMsg;
  constructor(private router: Router, private api: AdminService,private fcm: MessagingService) { }

  ngOnInit(): void {
    this.getNotification();
  }
  getNotification(){
    let params = new HttpParams();
		params = params.append("skip", this.skip.toString());
		params = params.append("limit", this.limit.toString()); 
		this.api.getData(apiUrl._getNotificationListing, params).subscribe(async (res) => { 
      console.log(res);
			this.totalCount = res.data.count;
      this.allData = res.data.list;  
			this.noData = true;
    },
    err => {
      console.log(err.error.message, "errr")
    })
  }
   
  	/** Infinite Scroll */
	onScrollDown() {
		console.log("scrolled down!!");
	}
	onModalScrollDown() {
		this.limit = this.totalCount;
		this.getNotification();
	}
  
  redirectTo(data) {
    const updateStatus = {
      id: data.id,
    }
    this.api.putData(apiUrl._getNotificationRead, updateStatus)
      .subscribe(async (res) => {
        if (data.notificationType == "11") {
          this.router.navigate([`/jobs/applicant/${data.jobId}/appdetail/`], {queryParams : { userId: `${data.userId}` }});
        } else if (data.notificationType == "12") {
          this.router.navigateByUrl(`/jobs/detail/${data.jobId}`);
        } else {
          this.router.navigate(["/account-settings/inventory-history"]);
        }
        this.getNotification()
      })
  }

  dateInMilisecond(date){
    const d1 = new Date(date)
    const miliSecond = d1.getTime();
    return miliSecond
  }
}
